import React, { Component } from 'react';
import {
    Link,
    // Switch,
    // Route,
    Redirect,
    Route,
    Switch,
    // Link,
    withRouter
} from "react-router-dom";
import PostType from './PostType';
import logoBioMedika from "../assets/logoBioMedika.svg";
import dashboardIcon from "../assets/new/dashboard.png";
import dashboardIconActive from "../assets/new/dashboardactive.png";
import garisbawahIconActive from "../assets/new/garisbawahactive.png";
import top10Icon from "../assets/new/top10.png";
import deptIcon from "../assets/new/icondept.png";
import kesimpulanIcon from "../assets/new/kesimpulan.png";
import people from "../assets/people_icon.png";
import admin from "../assets/admin.png";
import chevronRight from "../assets/font-awesome/black/png/32/chevron-right.png";

import back from "../assets/back.svg";
import $ from "jquery";
import Header from "./page-content/Navbar";
import Footer from "./Footer";
import Dropdown from "react-bootstrap/Dropdown";
import Cookies from 'js-cookie';

class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            login: localStorage.getItem("login"),
            detail_login: localStorage.getItem("detail_login"),
            path: this.props.history.location.pathname,
            menuLogout: false,
            openNavigation: false,
        }
        this.LogoutClick = this.LogoutClick.bind(this);
        this.HideLogout = this.HideLogout.bind(this);
        this.Logout = this.Logout.bind(this);
        this.active = this.active.bind(this);
        this.openNav = this.openNav.bind(this);
    }
    LogoutClick() {
        this.setState({
            menuLogout: !this.state.menuLogout,
        })
    }
    HideLogout() {
        this.setState({
            menuLogout: false,
        });
    }
    Logout() {
        this.setState({
            login: false,
        })
    }
    myalert() {
        alert("testing");
    }
    active() {

        if (window.innerWidth <= 767) {
            this.setState({
                openNavigation: !this.state.openNavigation,
            })
        }

        this.setState((state, props) => {
            return {
                path: props.location.pathname,
            };
        }, () => console.log(this.state.path))
    }
    openNav() {
        this.setState({
            openNavigation: !this.state.openNavigation,
        })

    }


    componentDidMount() {
        const match = this.props.match.path;
        console.log(this.state.path === match)
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.history.location.pathname !== this.state.path) {
            this.setState((state, props) => {
                return {
                    path: props.location.pathname,
                };
            }, () => console.log(this.state.path))
        }
    }

    render() {
        // if (Cookies.get("_login") == undefined) {
        // return (<Redirect to="/" />)
        // alert('null')
        // }
        const match = this.props.match.path;

        const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
            // <li
            //   className={"nav-item " + (this.state.path === "/admin/pendaftaran" ? "active" : "")}
            // >
            //   <a
            //     ref={ref}
            //     onClick={(e) => {
            //       e.preventDefault();
            //       onClick(e);
            //     }}
            //     className="nav-link"
            //     type="button"
            //   >
            //     <span style={{color:'#fff'}}>
            //       <i className="fa fa-id-card-o"></i> {children} &#x25bc;
            //     </span>
            //   </a>
            // </li>


            <li className={"nav-item sidebar-list"}>
                <a
                    ref={ref}
                    onClick={(e) => {
                        e.preventDefault();
                        onClick(e);
                    }}
                    className="nav-link"
                    type="button"
                >
                    <div className="sidebar-nav-div">
                        {<img alt='image2' className="people" src={(admin)} style={{ marginTop: '4px' }} />}
                        <span className="peopletext" style={{ color: (this.state.path === '/admin' ? '#C4E9CD' : 'white'), fontSize: '12px' }}>{children} &#x25bc;</span>
                    </div>
                </a>
            </li>

        ));

        return (
            <>

                <div
                    style={{
                        // backgroundColor: this.state.isFullScreen ? "white" : null,
                        // height: "800px",

                        height: 'auto'
                    }}
                >


                    <div id="wrapper" className={!this.state.openNavigation ? "toggled" : null}>

                        <div
                            id="sidebar-wrapper"
                            className="vertical-nav"
                        >
                            <img alt='image1' className="logo-bio-medika-new" src={logoBioMedika} />
                            <ul className="nav flex-column mb-0" style={{ marginTop: "40px" }}>

                                <li style={{ display: Cookies.get('biomedika-level') == 1 || Cookies.get('biomedika-level') == 4 ? null : 'none' }} className={"nav-item sidebar-list " + (this.state.path === "/admin/master-record" ? "active" : "")}>
                                    <Link to={`${this.props.match.path}/master-record`} onClick={this.active} className="nav-link" type="button">

                                        <div className="sidebar-nav-div">
                                            {<img alt='image8' className="people" src={people} style={{ filter: (this.state.path === '/admin/master-record' ? 'invert(26%) sepia(89%) saturate(1583%) hue-rotate(95deg) brightness(99%) contrast(26%)' : ''), marginTop: '4px' }} />}
                                            <span className="peopletext" style={{ color: (this.state.path === '/admin/master-record' ? '#C4E9CD' : 'white'), fontSize: '12px' }}>Registrasi</span>
                                        </div>

                                    </Link>
                                    {(this.state.path === '/admin/master-record' ? <img alt='image9' className="garisbawahactive" src={garisbawahIconActive} /> : null)}
                                </li>

                                <li style={{ display: Cookies.get('biomedika-level') == 2 || Cookies.get('biomedika-level') == 4 ? null : 'none' }} className={"nav-item sidebar-list " + (this.state.path === "/admin/master-exam" ? "active" : "")}>
                                    <Link to={`${this.props.match.path}/master-exam`} onClick={this.active} className="nav-link" type="button">

                                        <div className="sidebar-nav-div">
                                            {<img alt='image8' className="people" src={people} style={{ filter: (this.state.path === '/admin/master-exam' ? 'invert(26%) sepia(89%) saturate(1583%) hue-rotate(95deg) brightness(99%) contrast(26%)' : ''), marginTop: '4px' }} />}
                                            <span className="peopletext" style={{ color: (this.state.path === '/admin/master-exam' ? '#C4E9CD' : 'white'), fontSize: '12px' }}>Exam</span>
                                        </div>

                                    </Link>
                                    {(this.state.path === '/admin/master-exam' ? <img alt='image9' className="garisbawahactive" src={garisbawahIconActive} /> : null)}
                                </li>



                                <Dropdown style={{ display: Cookies.get('biomedika-level') == 3 || Cookies.get('biomedika-level') == 1 || Cookies.get('biomedika-level') == 4 ? null : 'none' }}>
                                    <Dropdown.Toggle
                                        as={CustomToggle}
                                        id="dropdown-custom-components"
                                    >Master
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="min-width" align={"end"}>
                                        <Dropdown.Item
                                            eventKey="1"
                                            as={Link}
                                            // to={`${this.props.match.path}/itreports`}
                                            to={`/admin/master-record`}
                                            onClick={this.active}
                                            style={{ display: Cookies.get('biomedika-level') == 3 ? null : 'none' }}
                                        >
                                            <span>
                                                <img src={chevronRight} width="14" /> Registrasi
                                            </span>
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            eventKey="2"
                                            as={Link}
                                            // to={`${this.props.match.path}/techreports`}
                                            to={`/admin/master-exam`}
                                            onClick={this.active}
                                            style={{ display: Cookies.get('biomedika-level') == 3 ? null : 'none' }}
                                        >
                                            <span>
                                                <img src={chevronRight} width="14" /> Exam
                                            </span>
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            eventKey="3"
                                            as={Link}
                                            // to={`${this.props.match.path}/techreports`}
                                            to={`/admin/master-konsultasi`}
                                            onClick={this.active}
                                            style={{ display: Cookies.get('biomedika-level') == 1 || Cookies.get('biomedika-level') == 3 ? null : 'none' }}
                                        >
                                            <span>
                                                <img src={chevronRight} width="14" /> Konsultasi / Poli
                                            </span>
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            eventKey="4"
                                            as={Link}
                                            // to={`${this.props.match.path}/techreports`}
                                            to={`/admin/master-dokter`}
                                            onClick={this.active}
                                            style={{ display: Cookies.get('biomedika-level') == 1 || Cookies.get('biomedika-level') == 3 ? null : 'none' }}
                                        >
                                            <span>
                                                <img src={chevronRight} width="14" /> Dokter
                                            </span>
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            eventKey="5"
                                            as={Link}
                                            // to={`${this.props.match.path}/techreports`}
                                            to={`/admin/penugasan-konsultasi`}
                                            onClick={this.active}
                                            style={{ display: Cookies.get('biomedika-level') == 1 || Cookies.get('biomedika-level') == 3 || Cookies.get('biomedika-level') == 4 ? null : 'none' }}
                                        >
                                            <span>
                                                <img src={chevronRight} width="14" /> Penugasan
                                            </span>
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            eventKey="6"
                                            as={Link}
                                            to={`/admin/laporan-finance`}
                                            onClick={this.active}
                                        // style={{ display: Cookies.get('biomedika-level') == 1 || Cookies.get('biomedika-level') == 3 ? null : 'none' }}
                                        >
                                            <span>
                                                <img src={chevronRight} width="14" /> Finance
                                            </span>
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            eventKey="7"
                                            as={Link}
                                            to={`/admin/master-users`}
                                            onClick={this.active}
                                            style={{ display: Cookies.get('biomedika-level') == 3 ? null : 'none' }}
                                        >
                                            <span>
                                                <img src={chevronRight} width="14" /> Users
                                            </span>
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            eventKey="8"
                                            as={Link}
                                            to={`/admin/master-log`}
                                            onClick={this.active}
                                            style={{ display: Cookies.get('biomedika-level') == 3 ? null : 'none' }}
                                        >
                                            <span>
                                                <img src={chevronRight} width="14" /> Log
                                            </span>
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>



                            </ul>
                            {/* <div id="sidebarCollapse" type="button" className="rotate">
                <img src={back} />
              </div> */}
                        </div>

                        <div id="page-content-wrapper">
                            <div className="container-fluid px-0" style={{ marginTop: "-30px" }}>
                                <div
                                    id="sidebarCollapse"
                                    type="button"
                                    className={this.state.openNavigation ? "rotate" : null}
                                    onClick={this.openNav}
                                >
                                    <img src={back} />
                                </div>
                                {/* <a href="#menu-toggle" onClick={this.openNav} className="btn btn-default" id="menu-toggle">Toggle Menu</a> */}
                                <Header />

                                <Switch>
                                    <Route path={`${match}/:postType`}>
                                        <PostType />
                                    </Route>
                                </Switch>

                            </div>
                        </div>
                    </div>

                    <a
                        className="fixed-tel"
                        title="Call Now"
                        onClick={() => history.back()}
                    >
                        <i className="fa fa-arrow-left" />
                    </a>


                    <Footer />
                </div>
            </>
        )
    }
}
export default withRouter(Index);